import McException403 from './McException403';

export default McException403;
